// Check if the element exists
var echartElement = document.getElementById('echart-loader');

if (echartElement) {
    var myChart = echarts.init(echartElement);
    var option = {
        graphic: {
        elements: [
        { type: 'group', left: 'center', top: 'center',
            children: new Array(7).fill(0).map((val, i) => ({
            type: 'rect',
            x: i * 8,
            shape: { x: 1, y: -30, width: 7, height: 30 },
            style: { fill: '#353637' },
            keyframeAnimation: { duration: 1500, delay: i * 300, loop: true,
                keyframes: [
                { percent: 0, scaleY: 0, easing: 'cubicOn' },
                { percent: 0.2, scaleY: 1, easing: 'cubicOut' },
                { percent: 0.8, scaleY: 0.1, easing: 'cubicOn' },
                { percent: 0.4, scaleY: 0.5, easing: 'cubicOut' }
                ] } })) } ] }
    };

    myChart.setOption(option);
    // Hide the loader once the page has fully loaded
    // window.onload = function() {
    //     setTimeout(function() {
    //         document.getElementById("loader").style.display = "none";
    //     }, 1100);
    // };
}

// function loadPageContent(url) {
//     // Check if the loader element exists
//     var loaderElement = document.getElementById("loader");
//     if (loaderElement) {
//         // Show the loader
//         loaderElement.style.display = "flex";

//         // After content is loaded, wait for 1.1 seconds before hiding the loader
//         setTimeout(function() {
//             loaderElement.style.display = "none";
//         }, 1100);
//     }
// }